
var sprite = require("/Users/fizz/side/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 30 30\" id=\"plus\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch --> <title>Combined Shape</title> <desc>Created with Sketch.</desc> <defs/> <g id=\"plus_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <path d=\"M14,14 L0,14 L0,16 L14,16 L14,30 L16,30 L16,16 L30,16 L30,14 L16,14 L16,-1.77635684e-15 L14,-2.14375088e-15 L14,14 Z\" id=\"plus_Combined-Shape\" fill=\"#000000\"/> </g> </symbol>";
module.exports = sprite.add(image, "plus");


/*****************
 ** WEBPACK FOOTER
 ** ./components/stepper/style/assets/plus.svg
 ** module id = 485
 ** module chunks = 0
 **/